import { useForm } from "react-hook-form";

import useUpdateLectureItem from "../hooks/useUpdateLectureItem";

import Input from "@/components/input/Input";
import Button from "@/components/Button";
import Select from "@/components/select/Select";
import { Checkbox, Spinner } from "@nextui-org/react";
import { useState } from "react";
import { convertToEmbedLink } from "../../../../utils/helpers";

function UpdateLectureItem({
    onCloseModal,
    courseId,
    lectureId,
    itemId,
    name,
    brief,
    type: oldType,
    quizDuration: quiz_duration,
    quizSuccessPercentage: quiz_success_percentage,
    quizAttemptLimit: quiz_attempt_limit,
    videoViews,
}) {
    const [openTypeContent, setOpenTypeContent] = useState(false);

    const {
        updateLectureItem,
        isUpdating,
        error: ApiError,
    } = useUpdateLectureItem();

    const {
        register,
        handleSubmit,
        formState: { errors },
        watch,
        setValue,
    } = useForm({
        defaultValues: {
            name,
            brief,
            type: oldType,
            quiz_duration,
            quiz_success_percentage,
            quizAttempt: quiz_attempt_limit === null ? "unlimited" : "limited",
            quiz_attempt_limit,
            video_views: videoViews,
        },
    });

    function onSubmit({
        name,
        brief,
        type,
        iframe = "",
        quiz_duration,
        quiz_success_percentage,
        quizAttempt,
        quiz_attempt_limit,
        video_views: videoViews,
    }) {
        let payload;

        if (type === "video") {
            const iframeFormat = convertToEmbedLink(iframe);
            payload = {
                name,
                brief,
                iframe: iframeFormat,
                type: type === oldType && "",
                lectureId,
                courseId,
                itemId,
                video_views: videoViews,
            };
        } else if (type === "quiz") {
            payload = {
                name,
                brief,
                type: type === oldType && "",
                quiz_duration,
                quiz_success_percentage,
                quiz_attempt_limit:
                    quizAttempt === "unlimited"
                        ? "unlimited"
                        : quiz_attempt_limit,
                lectureId,
                courseId,
                itemId,
            };
        }

        updateLectureItem(payload, {
            onSuccess: () => {
                onCloseModal?.();
            },
        });
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
            {/* Name */}
            <Input
                label={"العنوان "}
                name={"name"}
                type="text"
                register={register("name", {
                    maxLength: {
                        value: 30,
                        message: "الوصف الكورس يجب ان لا يزيد عن 30 حرف",
                    },
                    required: "برجاء إدخال العنوان ",
                })}
                error={
                    errors?.name?.message ||
                    ApiError?.response?.data?.errors?.name?.[0]
                }
                disabled={isUpdating}
            />

            {/* Brief */}
            <Input
                label={"الوصف"}
                name={"brief"}
                type="text"
                register={register("brief", {
                    maxLength: {
                        value: 50,
                        message: "الوصف الكورس يجب ان لا يزيد عن 50 حرف",
                    },
                    required: "برجاء إدخال الوصف",
                })}
                error={
                    errors?.brief?.message ||
                    ApiError?.response?.data?.errors?.brief?.[0]
                }
                disabled={isUpdating}
            />

            {/* Type */}
            <Select
                name="type"
                label="نوع المحتوي*"
                disabled={isUpdating}
                setValue={setValue}
                watch={watch}
                register={register("type", {
                    required: "برجاء إدخال نوع المحتوي",
                })}
                error={
                    errors?.type?.message ||
                    ApiError?.response?.data?.errors?.type?.[0]
                }
                options={[
                    { value: "video", text: "فيديو" },
                    { value: "quiz", text: "إختبار" },
                ]}
            />
            {/* videoLink */}
            {watch().type === "video" && (
                <>
                    <Input
                        label={"عدد المشاهدات"}
                        name={"video_views"}
                        type="number"
                        register={register("video_views", {
                            min: {
                                value: 0,
                                message:
                                    "عدد مشاهدات الفيديو يجب أن يكون على الأقل 0",
                            },
                        })}
                        error={
                            errors?.video_views?.message ||
                            ApiError?.response?.data?.errors?.video_views?.[0]
                        }
                        disabled={isUpdating}
                    />
                    <Checkbox
                        color="primary"
                        value={openTypeContent}
                        onChange={() => setOpenTypeContent((value) => !value)}
                    >
                        تعديل رابط الفيديو
                    </Checkbox>

                    {openTypeContent && (
                        <Input
                            label={"رابط الفيديو"}
                            name={"iframe"}
                            type="text"
                            register={register("iframe")}
                            error={
                                errors?.iframe?.message ||
                                ApiError?.response?.data?.errors?.iframe?.[0]
                            }
                            disabled={isUpdating}
                        />
                    )}
                </>
            )}
            {/* Quiz */}
            {watch().type === "quiz" && (
                <>
                    {/* QuizPercentage */}
                    <Input
                        label={"نسبة النجاح"}
                        name={"quiz_success_percentage"}
                        type="text"
                        register={register("quiz_success_percentage", {
                            required: "برجاء إدخال نسبة النجاح",
                        })}
                        error={
                            errors?.quiz_success_percentage?.message ||
                            ApiError?.response?.data?.errors
                                ?.quiz_success_percentage?.[0]
                        }
                        disabled={isUpdating}
                    />

                    {/* QuizTime */}
                    <Input
                        label={" وقت الأمتحان بالدقائق"}
                        name={"quiz_duration"}
                        type="text"
                        register={register("quiz_duration", {
                            required: "برجاء إدخال وقت الأمتحان",
                        })}
                        error={
                            errors?.quiz_duration?.message ||
                            ApiError?.response?.data?.errors?.quiz_duration?.[0]
                        }
                        disabled={isUpdating}
                    />

                    <Select
                        name="quizAttempt"
                        label="عدد مرات دخول الأمتحان*"
                        disabled={isUpdating}
                        setValue={setValue}
                        watch={watch}
                        register={register("quizAttempt", {
                            required: "برجاء إدخال عدد مرات دخول الأمتحان",
                        })}
                        error={errors?.quizAttempt?.message}
                        options={[
                            { value: "limited", text: "محدوده" },
                            { value: "unlimited", text: "غير محدوده" },
                        ]}
                    />

                    {/* Quiz Attempt Limit */}
                    {watch().quizAttempt === "limited" && (
                        <Input
                            label={" عدد مرات دخول الامتحان"}
                            name={"quiz_attempt_limit"}
                            type="text"
                            register={register("quiz_attempt_limit")}
                            error={
                                errors?.quiz_attempt_limit?.message ||
                                ApiError?.response?.data?.errors
                                    ?.quiz_attempt_limit?.[0]
                            }
                            disabled={isUpdating}
                        />
                    )}
                </>
            )}

            <div className="w-full py-3">
                <Button
                    type="primary"
                    className="flex items-center justify-center w-full leading-8"
                    disabled={isUpdating}
                >
                    {isUpdating ? (
                        <Spinner color="white" />
                    ) : (
                        "تعديل محتوي المحاضره"
                    )}
                </Button>
            </div>
        </form>
    );
}

export default UpdateLectureItem;
